import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import IntegrationUtilService from "../../integration/services/integration-util.service";
import { PaymentsRepositoryService } from "../../payments/services/payments-repository.service";
import { DwLoginInfo, DwLoginRegistrationInfoProvider, DwRegisterationInfo } from "@devwareapps/devware-cap";
import { map } from "rxjs/operators";
import { StripeSessionDetailsResult } from "../../payments/models/stripe-session-details-result.model";


@Injectable()
export class DwLoginRegistrationInfoProviderService implements DwLoginRegistrationInfoProvider {

    constructor(private integrationUtilService: IntegrationUtilService,
        private paymentsRepositoryService: PaymentsRepositoryService

    ) {
    }

    getLoginInfo(): Observable<DwLoginInfo> {
        return this.getStripeDetails()
            .pipe(map(stripeDetails => {
                if (stripeDetails) {
                    return {
                        userName: stripeDetails.CustomerEmail,
                    } as DwLoginInfo;
                } 

                return null;
        }));

    }
    getRegistrationInfo(): Observable<DwRegisterationInfo> {
          return this.getStripeDetails()
            .pipe(map(stripeDetails => {
                if (stripeDetails) {
                    return {
                        userName: stripeDetails.CustomerEmail,
                        email: stripeDetails.CustomerEmail,
                        firstName: stripeDetails.CustomerFirstName,
                        lastName: stripeDetails.CustomerLastName,
                    } as DwLoginInfo;
                } 

                return null;
        }));
    }

    private getStripeDetails(): Observable<StripeSessionDetailsResult> {
        const stripeToken = this.integrationUtilService.getStripeToken();
        if (stripeToken) {
            return this.paymentsRepositoryService.getStripeSessionDetails(stripeToken);
        } else {
            return of(null);
        }
    }
}